export const BUTTON_TEXT = 'Add to bag';
